import { useMemo } from "react";
import { DynamicOdds } from "@/components/PortableText/Odds/tempTypes";
import { AuthorBetMarket } from "@/graphql/gql/graphql";
import { filterEmpty } from "..";

interface DynamicOddsResponse {
  odds: DynamicOdds;
  title?: string;
  hide?: boolean;
}

export default function useDynamicOdds(
  authorOdds: AuthorBetMarket | undefined,
  eventName?: string
): DynamicOddsResponse {
  const authorProps = filterEmpty(authorOdds?.props ?? []);
  const titlePrefix = useMemo(() => {
    const text =
      authorOdds?.type == "CORE MARKET"
        ? filterEmpty(authorProps?.at(0)?.selections ?? [])
            .map((selection) => selection?.runnerName ?? "")
            .join(" ")
        : "";
    if (text) {
      return text + " ";
    }
    return "";
  }, [authorOdds?.type, authorProps]);

  return {
    odds: {
      selectionIds: [],
      _type: "",
      _key: ",",
      event: {
        name: eventName ?? "",
        id: 1,
      },
      title: "top title",
      odds: {
        type: "",
        props: authorProps,
      },
      marketType: { id: "marketType id", name: "marketType name" },
      oddsLeague: {
        eventTypeId: 1,
        name: "oddsLeague name",
        competitionIds: [],
      },
    },
    title: titlePrefix + (authorProps[0]?.marketName ?? ""),
    hide: !!authorProps,
  };
}
